<template>
  <div class="d-flex flex-column row-gap-4" v-if="folders.length">
    <div class="text-text-primary heading-md-bold">
      {{ $t('projects.ProjectsHeader.folders') }}
    </div>

    <ProjectsFoldersTemplate :folders="folders" :is-pending="isPending" />
    <!-- DIALOGS -->
    <DocumentsDeleteDialog
      v-if="projectsFolderDeleteDialogIsOpen"
      @close="closeProjectsFolderDeleteDialog"
      @validate-deletion="onDeletionValidation"
    />
    <DocumentsRenameDialog v-if="projectsFolderRenameDialogIsOpen"/>
    <ProjectsMoveRoomDialog v-if="projectsFolderMoveDialogIsOpen"/>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'

import AppCard from '@/common/AppCard.vue'
import { toast } from '@/common/utils/toast'
import DocumentsDeleteDialog from '@/project/documents/dialogs/DocumentsDeleteDialog.vue'
import DocumentsRenameDialog from '@/project/documents/dialogs/DocumentsRenameDialog.vue'
import ProjectsMoveRoomDialog from '@/projects/dialogs/ProjectsMoveRoomDialog.vue'
import { GET_PROJECTS_FOLDER_BY_ID, LOAD_PROJECTS_FOLDERS_TREE } from '@/store/modules/projects-folders/action_types'
import { DELETE_PROJECTS_FOLDER } from '@/store/modules/projects-folders-delete/action_types'
import {
  SET_PROJECTS_FOLDER_DELETE_DIALOG_IS_OPEN,
  SET_PROJECTS_FOLDER_TO_DELETE,
} from '@/store/modules/projects-folders-delete/mutation_types'
import { GET_PM_ROOMS_PROGRESSIVELY, GET_GUEST_ROOMS_PROGRESSIVELY } from '@/store/modules/rooms/action_types'

import ProjectsFoldersTemplate from './ProjectsFoldersTemplate.vue'

export default {
  name: 'ProjectsFolders',
  components: {
    ProjectsFoldersTemplate,
    DocumentsDeleteDialog,
    DocumentsRenameDialog,
    ProjectsMoveRoomDialog,
  },
  computed: {
    ...mapState('projectsFolders', ['projectsFoldersTree', 'getProjectsFoldersTreePending', 'currentProjectsFolder', 'projectsFolderByIdPending']),
    ...mapState('projectsFoldersRename', ['projectsFolderRenameDialogIsOpen']),
    ...mapState('projectsFoldersDelete', ['projectsFolderDeleteDialogIsOpen', 'projectsFolderToDelete']),
    ...mapState('projectsFoldersMove', ['projectsFolderMoveDialogIsOpen']),
    ...mapState('rooms', ['baseQueryParams']),
    isPending () {
      return this.projectsFolderByIdPending || this.getProjectsFoldersTreePending
    },
    folders () {
      return this.currentProjectsFolder.children || this.projectsFoldersTree
    },
  },
  methods: {
    ...mapActions('projectsFolders', [LOAD_PROJECTS_FOLDERS_TREE, GET_PROJECTS_FOLDER_BY_ID]),
    ...mapActions('projectsFoldersDelete', [DELETE_PROJECTS_FOLDER]),
    ...mapActions('rooms', [GET_PM_ROOMS_PROGRESSIVELY, GET_GUEST_ROOMS_PROGRESSIVELY]),
    ...mapMutations('projectsFoldersDelete', [SET_PROJECTS_FOLDER_DELETE_DIALOG_IS_OPEN, SET_PROJECTS_FOLDER_TO_DELETE]),
    closeProjectsFolderDeleteDialog () {
      this.SET_PROJECTS_FOLDER_DELETE_DIALOG_IS_OPEN(false)
      this.SET_PROJECTS_FOLDER_TO_DELETE({})
    },
    async onDeletionValidation () {
      try {
        await this.DELETE_PROJECTS_FOLDER(this.projectsFolderToDelete.id)

        if (this.currentProjectsFolder.id) {
          try {
            this.GET_PROJECTS_FOLDER_BY_ID({
              folderId: this.currentProjectsFolder.id,
            })
          } catch (error) {
            toast.error(
              this.$t('projects.ProjectsFolders.getFolderError',
              { name: this.currentProjectsFolder.name }),
            )
          }
        } else {
          try {
            this.LOAD_PROJECTS_FOLDERS_TREE()
          } catch (error) {
            toast.error(this.$t('projects.ProjectsFolders.getProjectsFoldersTreeError'))
          }
        }
        this.GET_PM_ROOMS_PROGRESSIVELY(this.baseQueryParams.pm)
        this.GET_GUEST_ROOMS_PROGRESSIVELY(this.baseQueryParams.guest)
      } catch (error) {
        toast.error(this.$t('projects.ProjectsFolders.deleteFolderError'))
      }
    },
  },
}
</script>
